import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Text from 'components/Text';
import { Divider, Button } from 'antd';
import { push } from 'connected-react-router';


/**
 * DefaultView
 */
const DefaultView = (props) => {
  return (
    <>  
      <Text size={16}>Mon profil</Text>
      <Divider />

      <ul>
        <li>
          <Button type="link" style={{ color: '#53b6ba' }} onClick={() => props.setCurrentView('email-form')}>Modifier mon adresse E-Mail</Button>
        </li>
        <li>
          <Button type="link" style={{ color: '#53b6ba' }} onClick={() => props.setCurrentView('profile-form')}>Modifier mes informations</Button>
        </li>
        <li>
          <Button type="link" style={{ color: '#53b6ba' }} onClick={() => props.push(`/orders/history`)}>Mes commandes</Button>
        </li>
      </ul>

    </>
  )    
}

const stateToProps = state => ({
  auth: state.auth,
  ui: state.ui,
})

const dispatchToProps = {
  push
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(DefaultView));